export default __webpack_public_path__ + "static/media/RCSLogo.92f3f39b.png";